import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet, Link } from "react-router-dom";
import { Menu, ConfigProvider, Dropdown, Space, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import api from "@/api";
import { findDeep, getAiModelDetail, format } from "@/utils";
import { publicPath } from "@/utils/base";

import dataJson from "@/../public/data.json";

const prefix = "myAiModelDetail";
import "./index.less";
import { cloneDeep } from "lodash-es";
import store from "@/stores";
import { useTypeKeyInfo } from "@/hooks/useTypeKeyInfo";
import { Breadcrumb } from "antd";

function MyAiModelDetail() {
  const { add, my_ai_model_detail, release, req_err } = dataJson;
  const [current, setCurrent] = useState("");
  const [dropdownItems, setDropdownItems] = useState<any[]>([]);
  const [dropdownList, setDropdownList] = useState([]);
  const [dropdownCur, setDropdownCur] = useState("");
  const [dropdownSelect, setDropdownSelect] = useState("");
  const [isAddVersion, setIsAddVersion] = useState<boolean>(true);
  const [isTampered, setIsTampered] = useState(false);

  const aiModelDetail = useSelector((state: any) => state.aiModelDetail);
  const appTypes = useSelector((state: any) => state.appTypes);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { typeKey, id } = useParams();

  const onClick = (e: any) => {
    if (current === e.key) {
      return;
    }
    setCurrent(e.key);
    navigate(`${publicPath}${e.item.props.url}/${typeKey}/${aiModelDetail?.id || id}`);
  };

  const dropdownOnClick = (e: any) => {
    setDropdownSelect(e.key);
    navigate(`${publicPath}/my_ai_model_detail/versionmanage/${typeKey}/${e.key}`);
  };

  const upgrade = async () => {
    const firstShowMode = findDeep(release.show_mode_arr, aiModelDetail?.histories[0]?.showMode);
    if (aiModelDetail?.histories?.length > 1 && firstShowMode.isUpgrade) {
      navigate(`${publicPath}/my_ai_model_detail/versionmanage/${typeKey}/${aiModelDetail?.histories[0].id}`);
    } else {
      try {
        const res: any = await api.upgradeVersionAiModel({ id: aiModelDetail?.currentId });
        if (res?.code == 200) {
          navigate(`${publicPath}/my_ai_model_detail/versionmanage/${typeKey}/${res.data.id}`);
          getAiModelDetail(res.data.id, undefined, () => {
            setIsTampered(true);
          });
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        message.error(errorInfo?.response?.data?.msg || req_err);
        return;
      }
    }
  };

  const to = (id: string, cur = current) => {
    switch (cur) {
      case "info":
        navigate(`${publicPath}/my_ai_model_detail/info/${typeKey}/${id}`);
        break;
      case "versionmanage":
        navigate(`${publicPath}/my_ai_model_detail/versionmanage/${typeKey}/${id}`);
        break;
      case "distribution_board":
        navigate(`${publicPath}/my_ai_model_detail/distribution_board/${typeKey}/${id}`);
        break;
      case "user_board":
        navigate(`${publicPath}/my_ai_model_detail/user_board/${typeKey}/${id}`);
        break;
      default:
        null;
    }
  };

  const getDropdownList = async () => {
    try {
      const res: any = await api.getAllNoPage({
        typeKeys: [typeKey],
      });
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data);
        const list = dataCopy.map((item: any) => {
          return {
            key: item.id,
            name: item.name,
            label: <a onClick={() => to(item.id)}>{item.name}</a>,
          };
        });
        setDropdownList(list || []);
        const cur = dataCopy?.find((item: any) => item.firstAppId === id);
        setDropdownCur(cur?.name || "");
      } else {
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  useEffect(() => {
    if (aiModelDetail) {
      const resData = cloneDeep(aiModelDetail);
      const resShowMode = findDeep(release.show_mode_arr, resData?.showMode);
      // const firstShowMode = findDeep(release.show_mode_arr, rulesDetail?.histories[0]?.showMode);
      // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
      if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
        const oldShowMode = resData?.histories[1]?.showMode;
        resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
      } else {
        resData.baseBtns = resShowMode?.baseBtns;
      }
      // if (resData?.showMode === "HISTORY" || (firstShowMode?.isUpgrade && resData.id !== firstShowMode?.id)) {
      //   setIsAddVersion(false);
      // } else {
      setIsAddVersion(!resData.baseBtns?.includes("upgrade"));
      // }

      getDropdownList();

      const newDropdownItems: any[] = aiModelDetail?.histories?.map((item: any) => {
        const showModeItem = findDeep(release.show_mode_arr, item?.showMode);
        console.log(showModeItem);
        return {
          key: item.id,
          label: (
            <div className={`${prefix}-dropdownItems`}>
              <div className={`${prefix}-dropdownItems-version one-line-ellipsis`} title={item.version}>
                {item?.version ? (
                  <div className={`${prefix}-dropdownItems-version-text one-line-ellipsis`}>
                    {my_ai_model_detail.version_v}
                    {item.version}
                  </div>
                ) : (
                  <div className={`${prefix}-dropdownItems-version-text one-line-ellipsis`}>
                    {my_ai_model_detail.new_version}
                  </div>
                )}
                <div className={`${prefix}-dropdownItems-version-status`} style={{ color: showModeItem.textColor }}>
                  {showModeItem.title}
                </div>
              </div>
              <div className={`${prefix}-dropdownItems-time`}>
                {format(new Date(Number(item.createTime)), "yy年MM月dd日 HH:mm")}
              </div>
            </div>
          ),
        };
      });
      setDropdownItems(newDropdownItems || []);
    }
  }, [aiModelDetail]);

  useEffect(() => {
    const pathArr = pathname.split("/");
    setCurrent(pathArr[pathArr.length - 3]);
    setDropdownSelect(id || "");
  }, [pathname]);

  useEffect(() => {
    setIsTampered(false);
    getAiModelDetail(id, undefined, () => {
      setIsTampered(true);
      navigate(-1);
    });
  }, [id]);

  const menus = useMemo(() => {
    const baseMenu =
      typeKey === "AGENT"
        ? my_ai_model_detail.menu
        : my_ai_model_detail.menu.filter((item: any) => item.key !== "analysis");
    if (!appTypes.length || !typeKey) return baseMenu;
    const arr = appTypes.filter((item: any) => {
      return item.key === typeKey;
    });
    if (!arr.length) return baseMenu;
    return baseMenu.map((item, index) => {
      if (index === 0) {
        return {
          ...item,
          label: arr[0].name + item.label,
        };
      }
      return item;
    });
  }, [my_ai_model_detail.menu, appTypes, typeKey]);

  const getAllTypes = async () => {
    const res: any = await api.getAllTypes();
    if (res.code === 200) {
      store.dispatch({
        type: "setAppTypes",
        payload: res.data,
      });
    }
  };

  useEffect(() => {
    getAllTypes();
  }, []);

  const { typeKeyInfo } = useTypeKeyInfo(typeKey, appTypes);

  const breadcrumbItems = [
    {
      title: (
        <Link to={`${publicPath}/staging`} state={{ tabKey: "3" }} className={`${prefix}-breadCrumb-link`}>
          {my_ai_model_detail.ai_text}
        </Link>
      ),
    },
    {
      title: (
        <Link to={`${publicPath}/my_ai_model/${typeKey}`} className={`${prefix}-breadCrumb-link`}>
          {typeKeyInfo?.name}
        </Link>
      ),
    },
    {
      title: (
        <Dropdown className={`${prefix}-breadCrumb-link`} menu={{ items: dropdownList, style: { maxHeight: "70vh" } }}>
          <Space style={{ color: "#1A1A1A" }}>
            {aiModelDetail?.histories?.[0]?.name || dropdownCur || "--"}
            <DownOutlined style={{ fontSize: "12px" }} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                iconSize: 14,
                itemHeight: 64,
                fontSize: 18,
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={menus}
            defaultOpenKeys={typeKey === "AGENT" ? ["distribute", "analysis"] : ["distribute"]}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-top`}>
          <div className={`${prefix}-breadCrumb`}>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          {current === "versionmanage" ? (
            <div className={`${prefix}-top-right`}>
              <Button type="link" disabled={isTampered || isAddVersion} onClick={upgrade}>
                {add + my_ai_model_detail.version}
              </Button>
              <Dropdown
                menu={{
                  items: dropdownItems,
                  selectable: true,
                  selectedKeys: [dropdownSelect],
                  onClick: dropdownOnClick,
                }}
                overlayClassName={`${prefix}-dropdown-overlay`}
              >
                <span className={`${prefix}-dropdown`}>
                  <Space>
                    {my_ai_model_detail.version}
                    <DownOutlined />
                  </Space>
                </span>
              </Dropdown>
            </div>
          ) : (
            <span></span>
          )}
        </div>

        <Outlet context={{ isTampered, setIsTampered }} />
      </ConfigProvider>
    </div>
  );
}

export default MyAiModelDetail;
